import { Button, Tooltip } from "@mui/material";
import { observer } from "mobx-react";
import { useRef, useState } from "react";

import { ChatLetterSummary } from "../../../../types/chat";
import { EditorIcon } from "../../../icons";
import { useChatStore } from "../../../../hooks/useChatStore";

interface ChatMessageLetterBoxProps {
  letter: ChatLetterSummary;
}

const ChatMessageLetterBox: React.FC<ChatMessageLetterBoxProps> = observer(({
  letter,
}) => {
  const chatStore = useChatStore();

  const latestGeneration = Math.max(0, ...chatStore.chatLetters.map((item) => item.generation));
  // The editor's own rule: only the latest version, in an open chat you own.
  const readOnly = chatStore.isInputDisabled || letter.generation !== latestGeneration;

  const labelRef = useRef<HTMLSpanElement>(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const label = readOnly ? `View ${letter.display_name}` : `Review and Edit ${letter.display_name}`;

  const onLetterClick = () => {
    void chatStore.openChatLetter(letter);
  };

  // Only show the full name when the label is actually truncated.
  const onTooltipOpen = () => {
    const el = labelRef.current;
    if (el && el.scrollWidth > el.clientWidth) {
      setIsTooltipOpen(true);
    }
  };

  return (
    <div style={{ width: "100%", minWidth: 0 }}>
      <Tooltip
        title={label}
        open={isTooltipOpen}
        onOpen={onTooltipOpen}
        onClose={() => setIsTooltipOpen(false)}
      >
        <Button
          variant="contained"
          color="primary"
          fullWidth
          startIcon={<EditorIcon size={16} />}
          onClick={onLetterClick}
          sx={{ minWidth: 0 }}
        >
          <span
            ref={labelRef}
            style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0, maxWidth: "300px" }}
          >
            {label}
          </span>
        </Button>
      </Tooltip>
    </div>
  );
});

export default ChatMessageLetterBox;
